export default __webpack_public_path__ + "703878bfb47f5a29a44b867ebbd86d14.svg";